import { render, staticRenderFns } from "./UpdateCallNotesAndTags.vue?vue&type=template&id=4a861322&"
import script from "./UpdateCallNotesAndTags.vue?vue&type=script&lang=js&"
export * from "./UpdateCallNotesAndTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports